import React, { useEffect, useState, useRef } from "react";
import "../../Tv/Iplbattle/iplbattle.css";
import "../simonsays/Simonsays.css";
import useUserInfo from "../../../Hooks/useUserInfo";
import { logPageView } from "../../../components/analytics";
import Task from "../Task";
import { useAudio } from "../../../Providers/AudioProvider";
import { userGameRewards } from "../../../apis/user";
// Removed SweetAlert import - using custom modals instead
import { FaQuestionCircle } from "react-icons/fa";
// Removed Bootstrap imports - using plain CSS popups instead
import logo from "../../../assets/images/coinlogo.png";

const UnoGame = () => {
  const { userDetails, watchScreen, updatewatchScreenInfo, updateUserInfo } =
    useUserInfo();
  const [isLoading, setIsLoading] = useState(false);
  const [score, setScore] = useState(0);
  const [displayScore, setDisplayScore] = useState(0);
  const [isGameActive, setIsGameActive] = useState(true);
  const [showInstructions, setShowInstructions] = useState(false);
  const [showApiLoading, setShowApiLoading] = useState(false);
  const [showApiSuccess, setShowApiSuccess] = useState(false);
  const [showApiError, setShowApiError] = useState(false);
  const [apiMessage, setApiMessage] = useState('');
  const [showExitConfirm, setShowExitConfirm] = useState(false);
  const [showLosePopup, setShowLosePopup] = useState(false);
  const [isMuted, setIsMuted] = useState(false);
  const playClick = useAudio();
  const iframeRef = useRef(null);

  useEffect(() => {
    logPageView("UNO GAME PAGE", "UNO GAME PAGE");
  }, []);

  const handleApiResponse = async (points) => {
    console.log(`🚀 Making API call with ${points} points for UNO game`);
    
    // Show loading modal
    setShowApiLoading(true);

    updateUserInfo((prev) => ({
      ...prev,
      isLoading: true,
    }));
    setIsLoading(true);
    
    try {
      const apiData = {
        gamePoints: points,
        gameType: "uno",
      };
      console.log(`📤 Sending API data:`, apiData);
      const res = await userGameRewards(apiData);
      if (res) {
        console.log(`✅ API call successful:`, res);
        
        // Close loading modal and show success
        setShowApiLoading(false);
        setApiMessage(res?.message || 'Your score has been recorded!');
        setShowApiSuccess(true);
        
        updateUserInfo((prev) => ({
          ...prev,
          isLoading: false,
        }));
        updatewatchScreenInfo((prev) => ({
          ...prev,
          LoginMessage: res?.message,
        }));
        setIsLoading(false);
      }
    } catch (error) {
      console.error("❌ API call failed:", error);
      
      // Close loading modal and show error
      setShowApiLoading(false);
      setApiMessage('Failed to send score. Please try again.');
      setShowApiError(true);
      
      updateUserInfo((prev) => ({
        ...prev,
        isLoading: false,
      }));
      setIsLoading(false);
    }
  };

  useEffect(() => {
    // Listen for messages from the iframe
    const handleMessage = (event) => {
      // Only process messages with specific UNO game types
      const { type, data } = event.data || {};
      
      // Filter for UNO specific message types
      if (type && type.startsWith('UNO_')) {
        console.log(`📨 UNO Game message received: ${type}`, data);
        
        switch (type) {
          case "UNO_GAME_OVER":
            console.log(`🎯 UNO Game Over - Received score: ${data?.score}`);
            setScore(data?.score || 0);
            // Only make API call if player won (score > 0)
            if (data?.score > 0) {
              console.log(`✅ Player won! Making API call with ${data.score} points`);
              handleApiResponse(data.score);
            } else {
              console.log(`❌ Player lost! Showing lose popup (score: ${data?.score})`);
              setShowLosePopup(true);
            }
            setDisplayScore(0);
            break;
          case "UNO_API_CALL":
            console.log(`🎯 UNO API Call - Received data:`, data);
            // Make API call with the provided data
            if (data?.gamePoints > 0) {
              console.log(`✅ Making API call with ${data.gamePoints} points`);
              handleApiResponse(data.gamePoints);
            } else {
              console.log(`❌ No points to send (gamePoints: ${data?.gamePoints})`);
            }
            break;
          case "UNO_SCORE_UPDATE":
            console.log(`📊 Score update: ${data?.score}`);
            setDisplayScore(data?.score || 0);
            break;
        }
      }
      // All other messages are ignored
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  const ExitGame = () => {  
    setShowExitConfirm(true);
      toogleMenu();  
  };

  const handleExitConfirm = () => {
    console.log("User chose to exit - sending score:", score);
    setShowExitConfirm(false);
    handleApiResponse(score);
    toogleMenu();
  };

  const handleExitCancel = () => {
    console.log("User chose to continue");
    setShowExitConfirm(false);
  };

  const handlePlayAgain = () => {
    console.log("User chose to play again");
    setShowLosePopup(false);
    // The game will auto-restart, so we just close the popup
  };

  const handleLoseExit = () => {
    console.log("User chose to exit after losing");
    setShowLosePopup(false);
    toogleMenu();
  };

  const toogleMenu = () => {
    playClick();
    updateUserInfo((prev) => ({
      ...prev,
      isPlay: false,
      currentComponent: Task,
      currentComponentText: "task",
      lastComponent: userDetails?.userDetails.currentComponent,
      lastComponentText: userDetails?.userDetails.currentComponentText,
      isMenu: true,
      menuCount: userDetails?.userDetails?.menuCount + 1,
    }));
  };

  const toggleMute = () => {
    const newMutedState = !isMuted;
    setIsMuted(newMutedState);
    
    // Send mute state to iframe
    if (iframeRef.current && iframeRef.current.contentWindow) {
      iframeRef.current.contentWindow.postMessage({
        type: 'UNO_MUTE_TOGGLE',
        data: { isMuted: newMutedState }
      }, '*');
    }
    
    console.log(`🔇 Mute toggled: ${newMutedState ? 'Muted' : 'Unmuted'}`);
  };

  return (
    <>
      {/* CSS for spinner animation and modal centering */}
      <style>
        {`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        
        /* Plain CSS popup styles like Dino game */
        .uno-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.8);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 9999;
        }
        
        .uno-full-popup {
          background: linear-gradient(135deg, #1a1a2e, #16213e);
          border-radius: 20px;
          padding: 30px;
          max-width: 500px;
          width: 90%;
          text-align: center;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.8);
          border: 2px solid #333;
          position: relative;
        }
        
        .uno-popup-content h3 {
          color: #8e2de2;
          margin-bottom: 20px;
          font-size: 2rem;
          font-weight: bold;
          text-shadow: 0 0 10px rgba(142, 45, 226, 0.5);
          text-transform: uppercase;
        }
        
        .uno-popup-content p {
          color: #fff;
          font-size: 1.2rem;
          margin-bottom: 20px;
          line-height: 1.4;
        }
        
        .uno-popup-content .btn {
          background: linear-gradient(45deg, #4a00e0, #8e2de2);
          color: white;
          border: none;
          border-radius: 8px;
          padding: 12px 24px;
          font-size: 1rem;
          font-weight: bold;
          cursor: pointer;
          transition: all 0.3s ease;
          margin: 5px;
          min-width: 120px;
        }
        
        .uno-popup-content .btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
        }
        
        .uno-popup-content .btn-secondary {
          background: rgba(255, 255, 255, 0.1);
          border: 1px solid rgba(255, 255, 255, 0.2);
        }
        
        .uno-popup-content .btn-secondary:hover {
          background: rgba(255, 255, 255, 0.2);
        }
        
        .uno-cancel-img {
          position: absolute;
          top: 15px;
          right: 15px;
          width: 25px;
          height: 25px;
          cursor: pointer;
          
        }
        
        .token-reward {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          margin: 20px 0;
        }
        
        .token-icon {
          width: 30px;
          height: 30px;
        }
        
        .spinner {
          width: 40px;
          height: 40px;
          border: 4px solid #333;
          border-top: 4px solid #8e2de2;
          border-radius: 50%;
          animation: spin 1s linear infinite;
          margin: 20px auto;
        }
        
        /* Responsive design */
        @media (max-width: 768px) {
          .uno-full-popup {
            width: 95%;
            padding: 25px;
          }
          
          .uno-popup-content h3 {
            font-size: 1.5rem;
          }
          
          .uno-popup-content p {
            font-size: 1rem;
          }
        }
        
        @media (max-width: 480px) {
          .uno-full-popup {
            width: 98%;
            padding: 20px;
          }
          
          .uno-popup-content h3 {
            font-size: 1.3rem;
          }
          
          .uno-popup-content p {
            font-size: 0.9rem;
          }
          
          .uno-popup-content .btn {
            font-size: 0.9rem;
            padding: 10px 20px;
            min-width: 100px;
          }
        }
        `}
      </style>
      <div
        className="menupointer"
        style={{
          height: "100%",
          width: "100%",
          pointerEvents: "fill",
          backgroundColor: "#000",
          zIndex: "2",
        }}
      >
      <div className="row">
        <div className="col-12">
          <header style={{ position: "absolute", width: "100%" }}>
            <div class="score-container1">
              <img
                onClick={() => {
                  if (!isLoading) {
                    ExitGame();
                  }
                }}
                src="https://d1ccopf5cw1hft.cloudfront.net/s3data/cancelicon.svg"
                className="cancel-imgflappy"
                style={{ 
                  cursor: isLoading ? "not-allowed" : "pointer", 
                  width: "25px",
                  opacity: isLoading ? 0.5 : 1
                }}
              />
              <div>
                <button
                  onClick={toggleMute}
                  style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    padding: '5px',
                    borderRadius: '50%',
                    transition: 'all 0.3s ease',
                    opacity: isMuted ? 0.6 : 1,
                    transform: isMuted ? 'scale(0.9)' : 'scale(1)'
                  }}
                  title={isMuted ? 'Unmute game sounds' : 'Mute game sounds'}
                >
                  <img
                    src={isMuted ? "https://d1ccopf5cw1hft.cloudfront.net/s3data/image+168.png" : "https://d1ccopf5cw1hft.cloudfront.net/s3data/image+167.png"}
                    alt={isMuted ? 'Unmute' : 'Mute'}
                    style={{
                      width: '25px',
                      height: '25px'
                    }}
                  />
                </button>
              <button
                style={{ 
                  color: "#03bb14",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  padding: "5px",
                  marginLeft: "10px"
                }}
                className="help-button"
                onClick={() => {
                  playClick();
                  setShowInstructions(!showInstructions);
                }}
              >
                <FaQuestionCircle size={24} />
              </button>
              </div>
              
            </div>
          </header>

          {/* Instructions Popup */}
          {showInstructions && (
            <div className="uno-overlay">
              <div className="uno-full-popup">
                <div className="uno-popup-content">
                  <img
                    src="https://d1ccopf5cw1hft.cloudfront.net/s3data/Xicon.png"
                    className="uno-cancel-img"
                    onClick={() => setShowInstructions(false)}
                    alt="Close"
                  />
                  <h3>HOW TO PLAY UNO</h3>
                  <div style={{ textAlign: 'left', marginBottom: '20px' }}>
                    <ol style={{ color: '#fff', fontSize: '0.9rem', lineHeight: '1.6' }}>
                      <li>MATCH CARDS BY COLOR, NUMBER OR ACTION</li>
                      <li>PLAY SPECIAL CARDS TO SKIP TURNS, REVERSE DIRECTION, OR MAKE OPPONENTS DRAW CARDS</li>
                      <li>SAY "UNO" WHEN YOU HAVE ONE CARD LEFT</li>
                      <li>THE FIRST PLAYER TO PLAY ALL THEIR CARDS WINS</li>
                      <li>IF YOU CAN'T PLAY A CARD, YOU MUST DRAW FROM THE PILE</li>
                    </ol>
                    <div style={{ marginTop: '20px' }}>
                      <h5 style={{ color: '#ffc107', marginBottom: '10px' }}>SPECIAL CARDS:</h5>
                      <ul style={{ color: '#fff', fontSize: '0.9rem', lineHeight: '1.6' }}>
                        <li>SKIP CARD (11): NEXT PLAYER MISSES THEIR TURN</li>
                        <li>REVERSE CARD (10): CHANGES DIRECTION OF PLAY</li>
                        <li>DRAW TWO CARD (+2): NEXT PLAYER DRAWS 2 CARDS AND LOSES THEIR TURN</li>
                        <li>WILD CARD: CHANGE THE COLOR OF PLAY</li>
                        <li>WILD DRAW FOUR CARD (+4): CHANGE COLOR AND NEXT PLAYER DRAWS 4 CARDS</li>
                      </ul>
                    </div>
                    <div style={{ marginTop: '20px' }}>
                      <h5 style={{ color: '#ffc107', marginBottom: '10px' }}>TOKEN REWARDS:</h5>
                      <ul style={{ color: '#fff', fontSize: '0.9rem', lineHeight: '1.6' }}>
                        <li>WIN THE GAME: GET 500 $MEMETV TOKENS</li>
                      </ul>
                    </div>
                  </div>
                  <button 
                    className="btn" 
                    onClick={() => setShowInstructions(false)}
                  >
                    GOT IT!
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* <button 
            onClick={() => {
              console.log("🧪 Test API call with 500 points");
              handleApiResponse(500);
            }}
            style={{
              background: "#007bff",
              color: "white",
              border: "none",
              padding: "5px 10px",
              borderRadius: "3px",
              cursor: "pointer",
              fontSize: "12px",
              marginLeft: "10px"
            }}
          >
            Test API
          </button> */}
          {/* <button 
            onClick={() => {
              console.log("🧪 Test game end message");
              // Simulate the message that should come from iframe
              const mockEvent = {
                data: {
                  type: 'UNO_GAME_OVER',
                  data: { score: 500 }
                },
                origin: window.location.origin
              };
              // Trigger the message handler manually
              const handleMessage = (event) => {
                console.log("📨 Message received:", event.data, "from origin:", event.origin);
                
                if (!event.data || typeof event.data !== 'object') {
                  console.log("❌ Invalid message structure:", event.data);
                  return;
                }

                const { type, data } = event.data;
                console.log("🔍 Parsed message - type:", type, "data:", data);

                switch (type) {
                  case "UNO_GAME_OVER":
                    console.log(`🎯 UNO Game Over - Received score: ${data?.score}`);
                    setScore(data?.score || 0);
                    if (data?.score > 0) {
                      console.log(`✅ Player won! Making API call with ${data.score} points`);
                      handleApiResponse(data.score);
                    } else {
                      console.log(`❌ Player lost! No API call made (score: ${data?.score})`);
                    }
                    setDisplayScore(0);
                    break;
                  case "UNO_SCORE_UPDATE":
                    console.log(`📊 Score update: ${data?.score}`);
                    setDisplayScore(data?.score || 0);
                    break;
                  default:
                    console.log("Unknown message type:", type);
                }
              };
              handleMessage(mockEvent);
            }}
            style={{
              background: "#28a745",
              color: "white",
              border: "none",
              padding: "5px 10px",
              borderRadius: "3px",
              cursor: "pointer",
              fontSize: "12px",
              marginLeft: "5px"
            }}
          >
            Test Game End
          </button> */}

          <iframe
            ref={iframeRef}
            src={"/UNO Card Game in JavaScript/index.html"}
            style={{
              height: "100vh",
              border: "none",
              width: "100vw",
              bottom: "0%",
              overflow: "hidden",
            }}
            title="UNO Card Game"
            onLoad={() => {
              console.log("🎮 UNO Game iframe loaded successfully");
              // Test if we can communicate with the iframe
              if (iframeRef.current && iframeRef.current.contentWindow) {
                iframeRef.current.contentWindow.postMessage({
                  type: 'UNO_INIT',
                  data: { message: 'UNO Game initialized' }
                }, '*');
              }
            }}
            onError={() => {
              console.error("❌ UNO Game iframe failed to load");
            }}
          />
        </div>
      </div>

      {/* API Loading Popup */}
      {showApiLoading && (
        <div className="uno-overlay">
          <div className="uno-full-popup">
            <div className="uno-popup-content">
              <h3>🎮 GAME COMPLETE!</h3>
              <p>Processing your score...</p>
              <div className="token-reward">
                <img src={logo} alt="Token" className="token-icon" />
                <p style={{ marginBottom: '0px', fontSize: '1.3rem' }}>
                  Points Earned: {score}
                </p>
              </div>
              <div className="spinner"></div>
              <p style={{ color: '#ccc', fontSize: '14px', marginTop: '15px' }}>
                Sending to server...
              </p>
            </div>
          </div>
        </div>
      )}

      {/* API Success Popup */}
      {showApiSuccess && (
        <div className="uno-overlay">
          <div className="uno-full-popup">
            <div className="uno-popup-content">
              <h3>✅ SUCCESS!</h3>
              <p>{apiMessage}</p>
              <button 
                className="btn" 
                onClick={() => setShowApiSuccess(false)}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}

      {/* API Error Popup */}
      {showApiError && (
        <div className="uno-overlay">
          <div className="uno-full-popup">
            <div className="uno-popup-content">
              <h3 style={{ color: '#ff416c' }}>❌ ERROR!</h3>
              <p>{apiMessage}</p>
              <button 
                className="btn btn-secondary" 
                onClick={() => setShowApiError(false)}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Exit Confirmation Popup */}
      {showExitConfirm && (
        <div className="uno-overlay">
          <div className="uno-full-popup">
            <div className="uno-popup-content">
              <h3 style={{ color: '#ffc107', fontSize: '1.5rem' }}>⚠️ EXIT GAME?</h3>
              <p style={{ fontSize: '1rem', lineHeight: '1.4' }}>
                Do you want to exit the game? Your score will be saved.
              </p>
              <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap' }}>
                <button 
                  className="btn" 
                  onClick={handleExitCancel}
                >
                  CONTINUE
                </button>
                <button 
                  className="btn btn-secondary" 
                  onClick={handleExitConfirm}
                >
                  EXIT
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* You Lost Popup */}
      {showLosePopup && (
        <div className="uno-overlay">
          <div className="uno-full-popup">
            <div className="uno-popup-content">
              <h3 style={{ color: '#ff416c' }}>YOU LOST!</h3>
              <p style={{ fontSize: '1.2rem', marginBottom: '20px' }}>
                MEMETV WON THIS ROUND. BETTER LUCK NEXT TIME!
              </p>
              <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', flexWrap: 'wrap' }}>
                <button 
                  className="btn" 
                  onClick={handlePlayAgain}
                >
                  PLAY AGAIN
                </button>
                <button 
                  className="btn btn-secondary" 
                  onClick={handleLoseExit}
                >
                  EXIT
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      </div>
    </>
  );
};

export default UnoGame;
